// extracted by mini-css-extract-plugin
module.exports = {"button":"CancelButton_button__ak-Nh","cancel":"CancelButton_cancel__3mS4-"};